import {LOCATE_SHOW_SHORTCUTS} from "../types";

const showOptionsSignature= (visible) => {
  return ({type: LOCATE_SHOW_SHORTCUTS, payload: {visibleShortcuts: visible}});
};
export default showOptionsSignature;